/**
 * A global namespace for aria-hidden.
 */
const ariaHidden = "aria-hidden";
export default ariaHidden;
